import { Assert } from '@team/assert';

/**
 * Возвращает `fallback`, если входное значение не определено или является `null`.
 * В ином случае возвращает преобразованное через `transformer` значение.
 */
export function transformOrFallback<T, U>(
  raw: Maybe<Nullable<T>>,
  transformer: (value: T) => U,
  fallback: U
) {
  if (Assert.isUndefined(raw)) {
    return fallback;
  }

  if (Assert.isNull(raw)) {
    return fallback;
  }

  return transformer(raw);
}
